import { TrackingContext } from '@ps/web-core-analytics';
import { merge } from 'lodash';
import React, { memo, useContext } from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import styles from './BetSlipWrapper.scss';
import BetReceipt from './components/BetReceipt/BetReceipt';
import BetSlip from './components/BetSlip/BetSlip';
import usePersistBetSlip from './hooks/usePersistBetSlip';

const BetSlipWrapper = memo(() => {
  const isBetReceiptActive = useSelector(select.betSlip.isBetReceiptActive);
  const trackingContextValue = useContext(TrackingContext);

  usePersistBetSlip();

  return (
    <TrackingContext.Provider
      value={merge(trackingContextValue, {
        widget: {
          widgetContext: 'BET_SLIP',
          widgetName: 'Sports Bet Slip Widget',
          widgetId: 'isp-sports-widget-bet-slip'
        }
      })}
    >
      {isBetReceiptActive ? (
        <BetReceipt className={styles.wrapper} />
      ) : (
        <BetSlip className={styles.wrapper} />
      )}
    </TrackingContext.Provider>
  );
});

export default BetSlipWrapper;
